import React, { createContext, useEffect, useMemo, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { MDialog } from 'common';
import { bool, func } from 'prop-types';
import * as R from 'ramda';

// Create a context with default values
export const CreateReconsignmentContext = createContext({});

export const setup = {
  destinations: [],
  isRecurring: false,
  product: null,
  rvp: 'Any',
  sourceLocations: [],
  transferDate: new Date(),
};

export const initialFilters = {
  consignmentStatus: 'ALL',
  inventoryStatus: 'ALL',
  origins: [],
  productStatus: 'UNRESERVED',
  volume: null,
};

export const allocation = {
  errors: [],
  fromLocations: [],
  overVol: false,
  toLocations: [],
};

const Create = ({ isNavHidden, setIsNavHidden }) => {
  const navigate = useNavigate();

  const [info, setInfo] = useState({
    ...setup,
    ...allocation,
  });
  const [filters, setFilters] = useState({
    ...initialFilters,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [validation, setValidation] = useState({});

  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const [bulkReconsignments, setBulkReconsignments] = useState([]);
  const [productDestinations, setProductDestinations] = useState([]);

  const originIds = useMemo(
    () =>
      R.prop('origins', filters).length
        ? R.map(({ originId }) => originId)(R.prop('origins', filters))
        : [],
    [filters]
  );

  useEffect(() => {
    !isNavHidden && setIsNavHidden(true);
  }, [isNavHidden, setIsNavHidden]);

  // Handling getting out of flow and need nav
  useEffect(() => {
    return () => setIsNavHidden(false);
  }, [setIsNavHidden]);

  const context = useMemo(
    () => ({
      bulkReconsignments,
      filters,
      info,
      isDrawerOpen,
      isNavHidden,
      originIds,
      productDestinations,
      setBulkReconsignments,
      setFilters,
      setInfo,
      setIsDrawerOpen,
      setIsNavHidden,
      setOpenDialog,
      setProductDestinations,
      setValidation,
      validation,
    }),
    [
      bulkReconsignments,
      filters,
      info,
      isDrawerOpen,
      isNavHidden,
      originIds,
      productDestinations,
      setIsNavHidden,
      setProductDestinations,
      validation,
    ]
  );

  const handleClose = () => {
    setIsNavHidden(false);
    navigate('../');
  };

  return (
    <CreateReconsignmentContext.Provider value={context}>
      <Outlet />
      <MDialog
        header="Unsaved Changes"
        leftButtonAction={() => setOpenDialog(false)}
        leftButtonText="Keep Editing"
        onClose={() => setOpenDialog(false)}
        open={openDialog}
        rightButtonAction={handleClose}
        rightButtonText="Leave Page"
      >
        <Typography color="textPrimary" component="span" variant="subtitle1">
          Are you sure you want to leave this page? You have unsaved reconsignment changes.
        </Typography>
      </MDialog>
    </CreateReconsignmentContext.Provider>
  );
};

Create.propTypes = {
  isNavHidden: bool.isRequired,
  setIsNavHidden: func.isRequired,
};

export default Create;
